import OneTimePassword from "./one-time-password";

export default OneTimePassword;